<template>
  <b-modal
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
    size="sm"
    id="progress-modal"
    ref="progress-modal"
    @hide="closeModal"
  >
    <h6 v-text="title" class="mb-2" />
    <b-progress
      :value="totalProgress"
      :show-progress="totalProgress != 100"
      :precision="1"
      :max="max"
      animated
      class="catalog mt-2"
    />
  </b-modal>
</template>

<script>
export default {
  name: "progress-modal",
  props: ["open", "total", "current", "title"],
  data() {
    return {
      max: 100,
    };
  },
  watch: {
    open() {
      if (this.open) this.$refs["progress-modal"].show();
      else this.$refs["progress-modal"].hide();
    },
  },
  computed: {
    totalProgress() {
      if (parseFloat(this.total) != 0) {
        return (parseFloat(this.current) / parseFloat(this.total)) * 100;
      } else {
        return 100;
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-progress-modal");
    },
  },
};
</script>

<style></style>
